import classNames from 'classnames';
import { useDropzone } from 'react-dropzone';

import type { FC } from 'react';

import styles from './ImageDropzone.module.scss';

type Props = {
  onDrop: (file: File) => void;
  className?: string;
};

const ImageDropzone: FC<Props> = ({ onDrop, className }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        onDrop(acceptedFiles[0]);
      }
    },
    accept: {
      'image/*': ['.jpg', '.jpeg', '.png'],
    },
  });

  return (
    <div
      className={classNames(
        styles.dropzone,
        {
          [styles.isDragActive]: isDragActive,
        },
        className
      )}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <div className={styles.label}>
        Drop only one file to upload
        <br /> or <span className={styles.link}>browse</span>
      </div>
    </div>
  );
};

export { ImageDropzone };
